module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col\">\n<a href=\"/\" class=\"logo\"><img src=\"/images/logo-livecom.jpg\" width=\"290\" height=\"65\" alt=\"Livecom - Vereinigung der österreichischen Veranstaltungsdienstleister\" class=\"img-fluid\"></a>\n<div class=\"nav-wrap\">\n<div id=\"mobileNav\" class=\"nav-mobile\"><i id=\"butMobileNav\" class=\"fis fi-bars\" aria-hidden=\"true\"></i><i id=\"butMobileNavClose\" class=\"fas fi-times\" aria-hidden=\"true\"></i></div>\n<nav>\n<ol id=\"topNav\">\n<%\nfor (let routeID in model.nav) {\nlet r = model.nav[routeID];\n%><li<%- (r.highlightEntry ? ' class=\"active\" aria-current=\"page\"' : '') %>><a href=\"<%= r.linkURL %>\" title=\"<%= r.name %>\"<%- r.linkTargetHTML %>><%- r.name %><%\nif (r.children.length) {\n%><div></div><%\n}\n%></a><%\nif (r.children.length) {\n%><div class=\"s\" data-id=\"<%= utils.media.getUrlReadyTitle(r.name); %>\">\n<div>\n<ol><%\nfor (let i=0; i<r.children.length; i++) {\nlet rs = r.children[i];\n%><li<%- (rs.highlightEntry ? ' class=\"active\" aria-current=\"page\"' : '') %>><a href=\"<%= rs.linkURL %>\" title=\"<%= rs.name %>\"<%- rs.linkTargetHTML %>><%- rs.name %></a></li><%\n}\n%></ol>\n</div>\n</div><%\n}\n%></li><%\n}\n%>\n</ol>\n</nav>\n</div>\n</div>\n</div>\n</div>\n<ol>\n<%- helpers.renderNavRoutesByCode(resourceData, 'main-sub-verein') %>\n</ol>"
  , __filename = "components\\templates\\header\\header.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col\">\n<a href=\"/\" class=\"logo\"><img src=\"/images/logo-livecom.jpg\" width=\"290\" height=\"65\" alt=\"Livecom - Vereinigung der österreichischen Veranstaltungsdienstleister\" class=\"img-fluid\"></a>\n<div class=\"nav-wrap\">\n<div id=\"mobileNav\" class=\"nav-mobile\"><i id=\"butMobileNav\" class=\"fis fi-bars\" aria-hidden=\"true\"></i><i id=\"butMobileNavClose\" class=\"fas fi-times\" aria-hidden=\"true\"></i></div>\n<nav>\n<ol id=\"topNav\">\n")
    ; __line = 9
    ; 
for (let routeID in model.nav) {
let r = model.nav[routeID];

    ; __line = 12
    ; __append("<li")
    ; __append( (r.highlightEntry ? ' class="active" aria-current="page"' : '') )
    ; __append("><a href=\"")
    ; __append(escapeFn( r.linkURL ))
    ; __append("\" title=\"")
    ; __append(escapeFn( r.name ))
    ; __append("\"")
    ; __append( r.linkTargetHTML )
    ; __append(">")
    ; __append( r.name )
    ; 
if (r.children.length) {

    ; __line = 14
    ; __append("<div></div>")
    ; 
}

    ; __line = 16
    ; __append("</a>")
    ; 
if (r.children.length) {

    ; __line = 18
    ; __append("<div class=\"s\" data-id=\"")
    ; __append(escapeFn( utils.media.getUrlReadyTitle(r.name) ))
    ; __append("\">\n<div>\n<ol>")
    ; __line = 20
    ; 
for (let i=0; i<r.children.length; i++) {
let rs = r.children[i];

    ; __line = 23
    ; __append("<li")
    ; __append( (rs.highlightEntry ? ' class="active" aria-current="page"' : '') )
    ; __append("><a href=\"")
    ; __append(escapeFn( rs.linkURL ))
    ; __append("\" title=\"")
    ; __append(escapeFn( rs.name ))
    ; __append("\"")
    ; __append( rs.linkTargetHTML )
    ; __append(">")
    ; __append( rs.name )
    ; __append("</a></li>")
    ; 
}

    ; __line = 25
    ; __append("</ol>\n</div>\n</div>")
    ; __line = 27
    ; 
}

    ; __line = 29
    ; __append("</li>")
    ; 
}

    ; __line = 31
    ; __append("\n</ol>\n</nav>\n</div>\n</div>\n</div>\n</div>\n<ol>\n")
    ; __line = 39
    ; __append( helpers.renderNavRoutesByCode(resourceData, 'main-sub-verein') )
    ; __append("\n</ol>")
    ; __line = 40
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\templates\header\header.ejs

}